<template>
    <div class="card">
        <div class="card-header header-elements-inline bg-light">
            <h6 class="card-title">Förhandsgranskning Fortnox Verifikat</h6>
        </div>
        <div class="card-body">
            <div v-if="errorMessage" class="alert alert-danger">
                {{ errorMessage }}
            </div>
            <div v-if="voucher">
                <div v-if="voucher.Description"><span>Beskrivning:</span> {{ voucher.Description }}</div>
                <div v-if="voucher.TransactionDate"><span>Transaktionsdatum:</span> {{ voucher.TransactionDate }}</div>
                <div v-if="voucher.CostCenter"><span>Kostnadsställe:</span> {{ voucher.CostCenter }}</div>
                <div v-if="voucher.Project"><span>Projekt:</span> {{ voucher.Project }}</div>
                <div v-if="voucher.ReferenceNumber"><span>Referensnummer:</span> {{ voucher.ReferenceNumber }}</div>
                <div v-if="voucher.ReferenceType"><span>Referenstyp:</span> {{ voucher.ReferenceType }}</div>
            </div>
        </div>
        <div v-if="voucher" class="table-responsive">
            <table class="table table-xxs">
                <thead>
                    <tr>
                        <th>Konto</th>
                        <th>Kostnadsställe</th>
                        <th>TransactionInformation</th>
                        <th class="text-right">Debit</th>
                        <th class="text-right">Kredit</th>
                        <th>Beskrivning</th>
                        <th>Projekt</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="(row, r_index) in voucher.VoucherRows"
                        :key="'r-' + r_index"
                    >
                        <td>{{ row.Account }}</td>
                        <td>{{ row.CostCenter }}</td>
                        <td>{{ row.TransactionInformation }}</td>
                        <td class="text-right">{{ row.Debit > 0 ? formatNumber(row.Debit, 2) : '' }}</td>
                        <td class="text-right">{{ row.Credit > 0 ? formatNumber(row.Credit, 2) : '' }}</td>
                        <td>{{ row.Description }}</td>
                        <td>{{ row.Project }}</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <th colspan="3"></th>
                        <th class="text-right" :class="{'text-danger': !isBalancing, 'text-success': isBalancing}">{{ formatNumber(sumDebit, 2) }}</th>
                        <th class="text-right" :class="{'text-danger': !isBalancing, 'text-success': isBalancing}">{{ formatNumber(sumCredit, 2) }}</th>
                        <th colspan="2"></th>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
</template>

<script>
import { formatNumber } from '@services/Helpers';
import { sumBy } from 'lodash';

export default {
    methods: {
        formatNumber,
    },
    props: {
        voucher: {
            type: Object,
            default() {
                return null;
            },
        },
        voucherError: {
            type: String,
            default: null,
        },
    },
    mounted() {
        this.$emit('checked:error', this.hasError);
    },
    watch: {
        hasError(val) {
            this.$emit('checked:error', val);
        },
    },
    computed: {
        errorMessage() {
            if (!this.isBalancing) {
                return 'Verifikatet balanserar inte.';
            }
            if (!this.allRowsHasAccounts) {
                return 'Verifikatet har rad(er) som saknar kontonummer.';
            }
            return this.voucherError;
        },
        isBalancing() {
            return this.sumDebit === this.sumCredit;
        },
        allRowsHasAccounts() {
            if (!this.voucher?.VoucherRows) {
                return true;
            }
            return !(this.voucher?.VoucherRows?.filter((item) => item.Account === 0).length > 0);
        },
        hasError() {
            return !!(this.errorMessage);
        },
        sumDebit() {
            if (this.voucher) {
                return Math.round(sumBy(this.voucher.VoucherRows, 'Debit') * 100) / 100;
            }
            return 0;
        },
        sumCredit() {
            if (this.voucher) {
                return Math.round(sumBy(this.voucher.VoucherRows, 'Credit') * 100) / 100;
            }
            return 0;
        },
    },
};
</script>
